<template>
  <div class="scrollableY">
       <div class="container">
             <div v-show="done" class="top20">
                <search-bundles></search-bundles>
             </div>
             <div  v-for="(item, i) in source" :key="i">
                <component :is="item.comp" :params="item.params" :index="i"></component>
            </div>
       </div>
       <div id="spinner" class="top160 bottom40"></div>
       <footerdiv ></footerdiv>
  </div>

</template>

<script>

import { AZEventBus } from '../components/AZEventBus'
import titleSection from '../components/cms/titleSection.vue'
import subTitleSection from '../components/cms/subTitleSection.vue'
import threeColumns from '../components/cms/threeColumns.vue'
import fourColumns from '../components/cms/fourColumns.vue'
import paragraph from '../components/cms/paragraph.vue'
import imageAndText from '../components/cms/imageAndText.vue'
import divider1 from '../components/cms/divider1.vue'
import searchBundles from '../components/SearchPBundles.vue'
import threeAds from '../components/cms/threeAds.vue'
import Footerdiv from '../components/Footer.vue'
import bundleComplete from '../components/cms/bundleComplete.vue'
import faq from '../components/cms/cmsFaq.vue'

export default {
    components: {titleSection, subTitleSection, threeColumns, paragraph, imageAndText, divider1, fourColumns, threeAds, Footerdiv, bundleComplete, searchBundles, faq},
    props: ['id'],
    data: function(){
        return {
            inited: false,
            source: [],
            done: false
        }
    },

    
    mounted: function(){
        var self = this

        function w(d){
            az.addRemSpinner(false, 'id', 'spinner')
      
            if(d.isLanding || d == 'notFound') 
                self.$router.push('/p404')

            if(d.isLive){
                self.source = JSON.parse(d.source)
                self.done = true

            } else {
                self.$router.push('/p404')
            }
        }

        function n(){
            az.addRemSpinner(false, 'id', 'spinner')
        }


        function init(){
            if(!self.id){
                self.id = 'discover' //process.env.VUE_APP_ROOT_DISCOVER
            }
             
            az.addRemSpinner(true, 'id', 'spinner')
            self.$root.app.apiClient.get('open/confirm/onepage/' + self.id, {}, w, n)
            
        }

        if(self.$root.app.doneFederating){
           init();
        }

        AZEventBus.$once('onFederate', msg => {
            init();
        });
        
    }

}



</script>